import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
export function ImplementosSection() {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], [-40, 40]);
  return <section ref={ref} className="py-24 md:py-32 bg-[#1E1A16]" data-id="element-166">
      <div className="container mx-auto px-6 md:px-12" data-id="element-167">
        <div className="flex flex-col md:flex-row-reverse items-center gap-16 lg:gap-24" data-id="element-168">
          <motion.div className="w-full md:w-1/2" initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} data-id="element-169">
            <h2 className="font-serif text-4xl md:text-5xl mb-8 leading-tight" data-id="element-170">
              Nuestros <br data-id="element-171" />
              <span className="text-gold italic" data-id="element-172">Implementos</span>
            </h2>
            <div className="w-16 h-[1px] bg-gold mb-8" data-id="element-173"></div>
            <p className="text-white/70 text-lg leading-relaxed font-light" data-id="element-174">
              Cada herramienta ha sido seleccionada por su precisión y
              rendimiento superior. Utilizamos máquinas profesionales de última
              generación, navajas de acero de la más alta calidad y productos
              premium.
              <br data-id="element-175" />
              <br data-id="element-176" />
              Mantenemos un estándar de higiene impecable con esterilización
              rigurosa, porque tu seguridad y la excelencia de nuestro trabajo
              son nuestra prioridad absoluta.
            </p>
          </motion.div>
          <motion.div className="w-full md:w-1/2" initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          ease: 'easeOut'
        }} data-id="element-177">
            <motion.div style={{
            y
          }} className="relative rounded-2xl overflow-hidden shadow-2xl shadow-gold/10 hover:-translate-y-2 transition-transform duration-500" data-id="element-178">
              <div className="absolute inset-0 bg-gold/5 mix-blend-overlay z-10 pointer-events-none" data-id="element-179"></div>
              <img src="https://cdn.magicpatterns.com/uploads/srTqKBAPhWCagwe7hR5ZvF/implementos.jpg" alt="Professional barber tools" className="w-full h-auto object-cover aspect-[4/5] md:aspect-square hover:scale-105 transition-transform duration-1000" data-id="element-180" />
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}